var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-legend"},[(_vm.uom)?_c('p',{staticClass:"map-legend__uom"},[_vm._v(_vm._s(_vm.uom))]):_vm._e(),(_vm.date)?_c('p',{staticClass:"map-legend__dateUpdate",domProps:{"innerHTML":_vm._s(_vm.date)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }